import React from "react";
import { useTranslation } from "@helpers/translate";

export const getPasswordRequirements = (password = "") => {
  const hasMinLength = password.length >= 8;
  const hasNumbersAndLetters = /^(?=.*\d)(?=.*[a-zA-Z])/.test(password);

  return {
    hasMinLength,
    hasNumbersAndLetters,
  };
};

const PasswordRequirements = ({ password = "" }) => {
  const { __ } = useTranslation();

  const passwordValid = getPasswordRequirements(password);

  const checkClass = (type) => {
    return passwordValid[type] ? "success" : "";
  };

  return (
    <ul className="auth-form__list-pattern list-pattern">
      <li className={`list-pattern__item ${checkClass("hasMinLength")}`}>
        <p className="list-pattern__text">{__("auth.requirements1")}</p>
      </li>

      <li
        className={`list-pattern__item ${checkClass(
          "hasNumbersAndLetters",
        )}`}
      >
        <p className="list-pattern__text">{__("auth.requirements2")}</p>
      </li>
    </ul>
  );
};

export default PasswordRequirements;
